//#region src/core/i18n/resolve-translation.ts
/**
* Translate a key with a translator, requiring the template params that key's English default declares.
*
* @param translator - Translator from `createTranslator`.
* @param key - Translation key, such as `seek.forward`.
* @param args - The key's template params, plus an optional `default` string.
* @public
*/
function resolveTranslation(translator, key, ...args) {
	const [params] = args;
	const translate = translator;
	return params !== void 0 ? translate(key, params) : translate(key);
}
//#endregion
export { resolveTranslation };
